export const profile = {
  "MainPage.AvailabilityCalendarForm.AvailabilityCalendarForm.datePicker":
    "availability-calendar-datepicker",
  "MainPage.AvailabilityCalendarForm.AvailabilityCalendarForm.titleInput":
    "availability-calendar-title-input",
  "MainPage.RowGallery.RowGallery.editButton": "RowGallery_EditButton",
  "MainPage.RowGallery.RowGallery.photo": "RowGallery_Photo",
  "ProfileStatsPage.HelpTip.helpTipContent": "help-tip-content",
  "ProfileStatsPage.StatCard.totalViewsCount": "total-views-count",
  "LinkToProfilePage.CopyLinkButtonsSection.copyButton": "copy-button",
  "MultiSelectList.MultiSelectListItems.wrapper": "multi-select-list-items",
  "EditBasicInfo.BasicInfoForm.Nationality.nationalitiesField":
    "nationalities-field",
  "Accordion.AccordionItem.expandable-row": "expandable-row",
  "SkillsGrid.SkillsGrid-data-row": "skills-grid-row",
  "Skills.SkillsForm.skillContainer": "skill-container",
  "LinkToProfile.ProfileLink.profileLink": "profile-link",
  "LinkToProfile.CopyProfileLink.button": "profile-link-copy-button",
  "MainPage.TrainingSection": "profile-training-container",
  "MainPage.AgencyDetails.field": "profile-agency-details-heading",
  "ManageContactsPage.AgencyDetails.row": "agency-details",
  "AddAgency.AgencyFilter.dropdown": "add-agency",
  "SkillsGrid.SkillsGrid.CellValue": "skills-grid-cellValue",
  "BasicInfo.Edit.SaveButton": "basicInfo-save-button",
  "Credit.Edit.SaveButton": "credit-save-button",
  "Credit.Edit.AddButton": "credit-add-button",
  "Skill.Edit.SaveButton": "skill-save-button",
  "Media.TitaniumUploader.FileInput": "file-input",
  "Media.FilePreview.DeleteButton": "delete-button",
  "Media.VideoForm.TitleInput": "video-title-input",
  "Media.MediaForm.SaveButton": "save-form",
  "Media.Video.AddReelButton": "add-reel-button",
  "Media.Video.UploadedVideo.List": "video-list",
  "Media.Video.UploadedVideo.Title": "video-title",
  "Media.MediaStorageContainer.CapacityBar": "media-storage-capacity",
  "Media.Audio.ConfirmButton": "alert-button-test-id-stub-Confirm",
  "Media.AudioForm.TitleInput": "audio-title-input",
  "Media.Audio.UploadedAudio.List": "audio-clip",
  "Media.AudioForm.EditTitleInput": "edit-audio-title-input",
  "Media.ThumbnailBar.ThumbnailBarItem": "thumbnailBar-element",
  "MainPage.MediaSection": "profile-media-container",
  "MainPage.MediaSection.Audio": "profile-media-visible-audio",
  "Media.Audio.ProcessingAudio": "audio-processing",
  "Media.Audio.HiddenAudio": "audio-hidden",
  "Photos.PhotographerName.Input": "photographer-name",
  "Photos.PhotographerDescription.Input": "photographer-description",
  "Photos.UploadedPhoto.card": "uploaded-photo",
  "Photo.UploadedPhoto.photoId": "photo-id",
  "Photo.UploadPhoto.input": "photo-input",
  "Photo.Headshot.editIcon": "edit-headshot",
  "Photo.Headshot.headshotOption": "photo-for-headshot",
  "Photo.Headshot.confirmHeadshot": "alert-button-test-id-stub-Continue",
  "Photo.Headshot.headshotId": "headshot-id",
  "Photo.Headshot.headshotPhoto": "headshot-photo",
  "Photo.Overlay.Hidden": "overlay",
  "MainPage.viewMyProfile.Btn": "button-icon-View my profile",
};
